module.exports = __webpack_public_path__ + "img/logo1.2c40b9c4.png";